// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {
  Checkbox,
  FormControlLabel,
  makeStyles,
  Typography,
} from '@material-ui/core';
import {colors} from '../../../../../../../../assets/styles/colors';

import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import CustomButton from '../../../../../../../../elements/CustomButton/CustomButton';

type Props = {
  description: string,
};

const useStyles = makeStyles(theme => ({
  item: {
    background: '#FFFFFF',
    border: '1px solid #E8E8ED',
    borderRadius: '8px',
  },
  topContent: {
    padding: theme.spacing(1.5),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  actions: {
    borderTop: '1px solid #E8E8ED',
  },
  buttonGroup: {
    borderColor: '#E8E8ED',
    display: 'flex',
  },
  button: {
    border: 'none',
    borderColor: '#E8E8ED',
    textTransform: 'none',
    fontWeight: 400,
    color: colors.grey600,
  },
  completeTask: {
    width: '100%',
    borderRight: '1px solid #E8E8ED',
  },
  deleteTask: {
    width: '100%',
    color: '#E54D7B',
  },
  deleteButton: {
    color: '#E54D7B',
  },
  description: {
    color: '#3A3A49',
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkboxLabel: {
    fontSize: 14,
    color: colors.grey600,
  },
  collaboratorChip: {
    backgroundColor: '#F4F4F6',
    padding: theme.spacing(0.2, 1.5),
    width: 'fit-content',
    borderRadius: '12px',
    '& p ': {
      color: '#717190',
      fontWeight: 500,
    },
  },
  checked: {
    color: `${colors.success}!important`,
  },
}));

export default function TaskItem(props: Props) {
  const {description} = props;
  const classes = useStyles();

  return (
    <div className={classes.item}>
      <div className={classes.topContent}>
        <div className={classes.collaboratorChip}>
          <Typography>Carlos H.</Typography>
        </div>
        <Typography className={classes.description}>{description}</Typography>
      </div>
      <div className={classes.actions}>
        <div className={classes.buttonGroup}>
          <div className={`${classes.center} ${classes.completeTask}`}>
            <FormControlLabel
              classes={{label: classes.checkboxLabel}}
              control={
                <Checkbox
                  classes={{checked: classes.checked}}
                  className={classes.checkbox}
                  // checked={saveInfo}
                  // onChange={handleToggleSaveInfo}
                  color="primary"
                  // disabled={disableInput}
                />
              }
              label="Completar"
            />
          </div>
          <div className={`${classes.center} ${classes.deleteTask}`}>
            <CustomButton
              startIcon={<DeleteOutlineIcon />}
              className={classes.deleteButton}
            >
              Eliminar
            </CustomButton>
          </div>
        </div>
      </div>
    </div>
  );
}

TaskItem.propTypes = {
  description: PropTypes.string.isRequired,
};
